export class KeyCode {
    public static M_CANCEL: number = 3;
    public static M_HELP: number = 6;
    public static M_BACK_SPACE: number = 8;
    public static M_TAB: number = 9;
    public static M_CLEAR: number = 12;
    public static M_RETURN: number = 13;
    public static M_ENTER: number = 14;
    public static M_SHIFT: number = 16;
    public static M_CONTROL: number = 17;
    public static M_ALT: number = 18;
    public static M_PAUSE: number = 19;
    public static M_CAPS_LOCK: number = 20;
    public static M_ESCAPE: number = 27;
    public static M_SPACE: number = 32;
    public static M_PAGE_UP: number = 33;
    public static M_PAGE_DOWN: number = 34;
    public static M_END: number = 35;
    public static M_HOME: number = 36;
    public static M_LEFT: number = 37;
    public static M_UP: number = 38;
    public static M_RIGHT: number = 39;
    public static M_DOWN: number = 40;
    public static M_PRINTSCREEN: number = 44;
    public static M_INSERT: number = 45;
    public static M_DELETE: number = 46;
    public static M_0: number = 48;
    public static M_1: number = 49;
    public static M_2: number = 50;
    public static M_3: number = 51;
    public static M_4: number = 52;
    public static M_5: number = 53;
    public static M_6: number = 54;
    public static M_7: number = 55;
    public static M_8: number = 56;
    public static M_9: number = 57;
    public static M_SEMICOLON: number = 59;
    public static M_EQUALS: number = 61;
    public static M_A: number = 65;
    public static M_B: number = 66;
    public static M_C: number = 67;
    public static M_D: number = 68;
    public static M_E: number = 69;
    public static M_F: number = 70;
    public static M_G: number = 71;
    public static M_H: number = 72;
    public static M_I: number = 73;
    public static M_J: number = 74;
    public static M_K: number = 75;
    public static M_L: number = 76;
    public static M_M: number = 77;
    public static M_N: number = 78;
    public static M_O: number = 79;
    public static M_P: number = 80;
    public static M_Q: number = 81;
    public static M_R: number = 82;
    public static M_S: number = 83;
    public static M_T: number = 84;
    public static M_U: number = 85;
    public static M_V: number = 86;
    public static M_W: number = 87;
    public static M_X: number = 88;
    public static M_Y: number = 89;
    public static M_Z: number = 90;
    public static M_CONTEXT_MENU: number = 93;
    public static M_NUMPAD0: number = 96;
    public static M_NUMPAD1: number = 97;
    public static M_NUMPAD2: number = 98;
    public static M_NUMPAD3: number = 99;
    public static M_NUMPAD4: number = 100;
    public static M_NUMPAD5: number = 101;
    public static M_NUMPAD6: number = 102;
    public static M_NUMPAD7: number = 103;
    public static M_NUMPAD8: number = 104;
    public static M_NUMPAD9: number = 105;
    public static M_MULTIPLY: number = 106;
    public static M_ADD: number = 107;
    public static M_SEPARATOR: number = 108;
    public static M_SUBTRACT: number = 109;
    public static M_DECIMAL: number = 110;
    public static M_DIVIDE: number = 111;
    public static M_F1: number = 112;
    public static M_F2: number = 113;
    public static M_F3: number = 114;
    public static M_F4: number = 115;
    public static M_F5: number = 116;
    public static M_F6: number = 117;
    public static M_F7: number = 118;
    public static M_F8: number = 119;
    public static M_F9: number = 120;
    public static M_F10: number = 121;
    public static M_F11: number = 122;
    public static M_F12: number = 123;
    public static M_F13: number = 124;
    public static M_F14: number = 125;
    public static M_F15: number = 126;
    public static M_F16: number = 127;
    public static M_F17: number = 128;
    public static M_F18: number = 129;
    public static M_F19: number = 130;
    public static M_F20: number = 131;
    public static M_F21: number = 132;
    public static M_F22: number = 133;
    public static M_F23: number = 134;
    public static M_F24: number = 135;
    public static M_NUM_LOCK: number = 144;
    public static M_SCROLL_LOCK: number = 145;
    public static M_COMMA: number = 188;
    public static M_PERIOD: number = 190;
    public static M_SLASH: number = 191;
    public static M_BACK_QUOTE: number = 192;
    public static M_OPEN_BRACKET: number = 219;
    public static M_BACK_SLASH: number = 220;
    public static M_CLOSE_BRACKET: number = 221;
    public static M_QUOTE: number = 222;
    public static M_META: number = 224;
}
